<template>
  <el-form
    ref="ebFtPlanEditFormRef"
    :rules="ebFtPlanEditFormRules"
    :model="ebFtPlanEditForm"
    class="form-panel"
    label-position="top"
    :disabled="!isAddManiFest || notEditable"
  >
    <el-row>
      <el-col>
         <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">基本信息</span>
                </el-col>
                </div>
           </el-row>
        <el-row class="content-panel">
          <el-col>
            <el-row :gutter="10">
              <el-col :span="4" style="width: 20%">
                <el-form-item
                  label="提单号:"
                  prop="ebOrder.mblNo"
                >
                  <el-input
                    size="mini"
                    v-model="ebFtPlanEditForm.ebOrder.mblNo"
                    case="upper"
                    :disabled="!isAddManiFest2"
                     maxlength="20"
                    :title="ebFtPlanEditForm.ebOrder.mblNo"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-form-item
                  class="requiredStyle"
                  label="船公司:"
                  prop="ebOrder.carrierName"
                >
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_carrier"
                    :query-method="associate_queryMethod_carrier"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="custAlias"
                    value-prop="custNameCn"
                    placeholder=""
                    v-model="ebFtPlanEditForm.ebOrder.carrierName"
                    :title="ebFtPlanEditForm.ebOrder.carrierName"
                    size="mini"
                    @change="carrierChange"
                    :disabled="!isAddManiFest2"
                    case="upper"
                    ref="ebOrder.carrierName"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-form-item  label="船代:">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_carrier"
                    :query-method="associate_queryMethod_shipAgencyName"
                    class="input_length"
                    clearable
                    :disabled="!isAddManiFest2"
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="custAlias"
                    value-prop="custAlias"
                    placeholder=""
                    v-model="ebFtPlanEditForm.ebOrder.shipAgencyName"
                    :title="ebFtPlanEditForm.ebOrder.shipAgencyName"
                    size="mini"
                    @change="shipAgencyChange"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-row>
                  <el-col :span="14">
                    <el-form-item
                      label="报关船名/航次:"
                      prop="ebOrder.customsVesselName"
                    >
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_vessel"
                        :query-method="associate_queryMethod_vessel"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="vesselName"
                        value-prop="vesselName"
                        placeholder=""
                        v-model="ebFtPlanEditForm.ebOrder.customsVesselName"
                        :title="ebFtPlanEditForm.ebOrder.customsVesselName"
                        size="mini"
                        @change="vesselChange"
                        :disabled="!isAddManiFest2"
                        case="upper"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item>
                      <label slot="label" class="label_no"></label>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_voyage"
                        :query-method="associate_queryMethod_voyage"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prcargoNameop="voyage"
                        value-prop="voyage"
                        placeholder=""
                        v-model="ebFtPlanEditForm.ebOrder.customsVoyage"
                        :title="ebFtPlanEditForm.ebOrder.customsVoyage"
                        size="mini"
                        @change="voyageChange"
                        name="voyage"
                        :disabled="!isAddManiFest2"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-form-item label="提单性质:">
                  <el-select
                    class="length_input"
                    size="mini"
                    :disabled="!isAddManiFest2"
                    v-model="ebFtPlanEditForm.ebFtPlan.billProperty"
                    :title="ebFtPlanEditForm.ebFtPlan.billProperty"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in billPropertyOptions"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="4" style="width: 20%">
                <el-form-item
                  class="requiredStyle"
                  label="卸货港:"
                  prop="ebOrder.podName"
                >
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="portNameEn"
                    placeholder=""
                    v-model="ebFtPlanEditForm.ebOrder.podName"
                    :title="ebFtPlanEditForm.ebOrder.podName"
                    size="mini"
                    @change="podChange"
                    :disabled="!isAddManiFest2"
                    case="upper"
                    ref="ebOrder.podName"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-form-item label="目的港:">
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    :disabled="!isAddManiFest2"
                    label-prop="portNameEn"
                    value-prop="portNameEn"
                    placeholder=""
                    v-model="ebFtPlanEditForm.ebFtPlan.placeOfDestName"
                    :title="ebFtPlanEditForm.ebFtPlan.placeOfDestName"
                    size="mini"
                    @change="placeOfDestChange"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-form-item
                  class="requiredStyle"
                  label="开航日期:"
                  prop="ebOrder.etd"
                >
                  <el-date-picker
                    v-model="ebFtPlanEditForm.ebOrder.etd"
                    :title="ebFtPlanEditForm.ebOrder.etd"
                    align="right"
                    type="date"
                    style="width: 100%"
                    size="mini"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    :disabled="!isAddManiFest2"
                    ref="ebOrder.etd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-form-item
                  class="requiredStyle"
                  label="运输条款:"
                  prop="ebOrder.mblTransportTermFrom"
                >
                  <el-col :span="11" style="padding: 0px">
                    <el-select
                      class="length_input"
                      size="mini"
                      v-model="ebFtPlanEditForm.ebOrder.mblTransportTermFrom"
                      :title="ebFtPlanEditForm.ebOrder.mblTransportTermFrom"
                      placeholder="请选择"
                      :disabled="!isAddManiFest2"
                      @change="validateField('ebOrder.mblTransportTermFrom')"
                      ref="ebOrder.mblTransportTermFrom"
                    >
                      <el-option
                        v-for="item in hblTransportTermOptions"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2">-</el-col>
                  <el-col :span="11" style="padding: 0px">
                    <el-select
                      class="length_input"
                      size="mini"
                      v-model="ebFtPlanEditForm.ebOrder.mblTransportTermTo"
                      :title="ebFtPlanEditForm.ebOrder.mblTransportTermTo"
                      placeholder="请选择"
                      :disabled="!isAddManiFest2"
                      @change="validateField('ebOrder.mblTransportTermTo')"
                    >
                      <el-option
                        v-for="item in hblTransportTermOptions"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-form-item
                  class="requiredStyle"
                  label="付费方式:"
                  prop="ebOrder.mblPaymentType"
                >
                  <el-select
                    class="length_input"
                    size="mini"
                    v-model="ebFtPlanEditForm.ebOrder.mblPaymentType"
                    :title="ebFtPlanEditForm.ebOrder.mblPaymentType"
                    placeholder="请选择"
                    :disabled="!isAddManiFest2"
                    @change="changeMblPaymentType"
                    ref="ebOrder.mblPaymentType"
                  >
                    <el-option
                      v-for="item in hblPaymentTypeOptions"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="4" style="width: 20%">
                <el-form-item
                  label="起运港:"
                  prop="ebOrder.polName"
                >
                  <el-associate
                    style="width: 100%"
                    :columns="associate_columns_po"
                    :query-method="associate_queryMethod_po"
                    class="input_length"
                    clearable
                    :query-length="0"
                    :default-first-option="true"
                    label-prop="portNameEn"
                    value-prop="portNameEn"
                    placeholder=""
                    v-model="ebFtPlanEditForm.ebOrder.polName"
                    :title="ebFtPlanEditForm.ebOrder.polName"
                    size="mini"
                    @change="polChange"
                    :disabled="!isAddManiFest1"
                    case="upper"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4" style="width: 20%">
                <el-row>
                  <el-col :span="14">
                    <el-form-item
                      label="大船船名/航次:"
                      prop="ebOrder.vesselNameEn"
                    >
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_vessel"
                        :query-method="associate_queryMethod_vessel"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prop="vesselName"
                        value-prop="vesselName"
                        placeholder=""
                        v-model="ebFtPlanEditForm.ebOrder.vesselNameEn"
                        :title="ebFtPlanEditForm.ebOrder.vesselNameEn"
                        size="mini"
                        @change="realVesselChange"
                        :disabled="!isAddManiFest2"
                        case="upper"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item>
                      <label slot="label" class="label_no"></label>
                      <el-associate
                        style="width: 100%"
                        :columns="associate_columns_voyage"
                        :query-method="associate_queryMethod_voyage"
                        class="input_length"
                        clearable
                        :query-length="0"
                        :default-first-option="true"
                        label-prcargoNameop="voyage"
                        value-prop="voyage"
                        placeholder=""
                        v-model="ebFtPlanEditForm.ebOrder.voyage"
                        :title="ebFtPlanEditForm.ebOrder.voyage"
                        size="mini"
                        @change="realVoyageChange"
                        name="voyage"
                        :disabled="!isAddManiFest2"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8" style="width: 20%">
                <el-col :span="24">
                  <el-form-item label="舱单拒绝原因:">
                    <el-input
                      case="upper"
                      size="mini"
                      :disabled="!isAddManiFest2"
                      v-model="ebFtPlanEditForm.ebFtPlan.manifestFeedback"
                      :title="ebFtPlanEditForm.ebFtPlan.manifestFeedback"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 基本信息-end -->
    <!-- 收发通信息信息-start -->
    <el-row class="panel-top">
      <el-col>
        <el-row class="title-panel-external">
          <div class="title-panel">
                  <el-col>
                  <span class="title-text">收发通信息</span>
                </el-col>
                </div>
        </el-row>
        <el-row class="content-panel" id="check">
          <el-col>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-row class="cargo-type transceiver-cargo-type">
              <el-row class="title-panel cargo-type-title-panel transceiver-info">
                <el-col>
                  <span class="title-text cargo-title-text">发货人</span>
                </el-col>
              </el-row>
                  <el-col>
                    <el-form-item
                      class="requiredStyle"
                      label="发货人名称:"
                      prop="ebFtPlanPartySh.partyMainName"
                    >
                      <el-input
                        size="mini"
                        v-model="ebFtPlanEditForm.ebFtPlanPartySh.partyMainName"
                        case="upper"
                        maxlength="100"
                        :title="ebFtPlanEditForm.ebFtPlanPartySh.partyMainName"
                        ref="ebFtPlanPartySh.partyMainName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          class="requiredStyle"
                          label="国家(地区):"
                          prop="ebFtPlanPartySh.countryName"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_country"
                            :query-method="associate_queryMethod_country"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="countryNameEn"
                            value-prop="countryNameEn"
                            placeholder=""
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartySh.countryName
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.countryName"
                            size="mini"
                            name="countryName"
                            @change="validateFieldSh"
                            case="upper"
                            ref="ebFtPlanPartySh.countryName"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="发货人代码:"
                          prop="ebFtPlanPartySh.partySysCode"
                        >
                          <el-input
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartySh.partySysCode
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.partySysCode"
                            case="upper"
                            maxlength="50"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          label="发货人企业代码类型:"
                          prop="ebFtPlanPartySh.aeoCodeType"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_aeoCodeType"
                            :query-method="associate_queryMethod_aeoCodeType_Sh"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :allow-create="true"
                            :default-first-option="true"
                            label-prop="aeoCodeType"
                            value-prop="aeoCodeType"
                            placeholder=""
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartySh.aeoCodeType
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.partySysCode"
                            size="mini"
                            name="aeoCodeType"
                            ref="ebFtPlanPartySh.aeoCodeType"
                            @focus="validateFieldShCountryName"
                            @change="changShAeoCodeType"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="发货人企业代码:"
                        >
                          <el-input
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartySh.partyMainCode
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.partyMainCode"
                            case="upper"
                             maxlength="100"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-form-item
                      class="requiredStyle"
                      label="地址:"
                      prop="ebFtPlanPartySh.partyAddress"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        type="textarea"
                        :rows="3"
                        v-model="ebFtPlanEditForm.ebFtPlanPartySh.partyAddress"
                        :title="ebFtPlanEditForm.ebFtPlanPartySh.partyAddress"
                         maxlength="200"
                        ref="ebFtPlanPartySh.partyAddress"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item
                      label="中文名称:"
                      prop="ebFtPlanPartySh.partyMainNameCn"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebFtPlanEditForm.ebFtPlanPartySh.partyMainNameCn"
                        :title="ebFtPlanEditForm.ebFtPlanPartySh.partyMainNameCn"
                         maxlength="100"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="电话:" prop="ebFtPlanPartySh.tel">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartySh.tel"
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.tel"
                             maxlength="50"
                            ref="ebFtPlanPartySh.tel"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="传真:" prop="ebFtPlanPartySh.fax">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartySh.fax"
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.fax"
                             maxlength="50"
                            ref="ebFtPlanPartySh.fax"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          label="邮箱:"
                          prop="ebFtPlanPartySh.email"
                        >
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartySh.email"
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.email"
                             maxlength="50"
                            ref="ebFtPlanPartySh.email"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="AEO企业代码"
                          prop="ebFtPlanPartySh.aeoNo"
                        >
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartySh.aeoNo"
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.aeoNo"
                             maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          label="具体联系人"
                          prop="ebFtPlanPartySh.contactPerson"
                        >
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartySh.contactPerson
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.contactPerson"
                             maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="具体联系人电话"
                          prop="ebFtPlanPartySh.contactTel"
                        >
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartySh.contactTel
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartySh.contactTel"
                             maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5"></el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                 <el-row class="cargo-type transceiver-cargo-type">
              <el-row class="title-panel cargo-type-title-panel transceiver-info">
                <el-col>
                  <span class="title-text cargo-title-text">收货人</span>
                </el-col>
              </el-row>
                  <el-col style="position: relative">
                    <div style="position: absolute; left: 90px; top: 2px">
                      <el-radio
                        v-model="ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName"
                        :title="ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName"
                        label="TO ORDER"
                      >TO ORDER
                      </el-radio
                      >
                    </div>
                    <el-form-item
                      class="requiredStyle"
                      label="收货人名称:"
                      prop="ebFtPlanPartyCn.partyMainName"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName"
                        :title="ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName"
                         maxlength="100"
                        ref="ebFtPlanPartyCn.partyMainName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          :class="['requiredStyle',ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName === 'TO ORDER'? 'noRequiredStyle': '']"
                          label="国家(地区):"
                          prop="ebFtPlanPartyCn.countryName"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_country"
                            :query-method="associate_queryMethod_country"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="countryNameEn"
                            value-prop="countryNameEn"
                            placeholder=""
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyCn.countryName
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.countryName"
                            size="mini"
                            name="countryName"
                            @change="validateFieldCn"
                            case="upper"
                            ref="ebFtPlanPartyCn.countryName"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="收货人代码:"
                          prop="ebFtPlanPartyCn.partySysCode"
                        >
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyCn.partySysCode
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.partySysCode"
                             maxlength="50"
                            ref="ebFtPlanPartyCn.partySysCode"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          :class="['requiredStyle',ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName === 'TO ORDER'? 'noRequiredStyle': '']"
                          label="收货人企业代码类型:"
                         prop="ebFtPlanPartyCn.aeoCodeType"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_aeoCodeType"
                            :query-method="associate_queryMethod_aeoCodeType_Cn"
                            class="input_length"
                            clearable
                            :allow-create="true"
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="aeoCodeType"
                            value-prop="aeoCodeType"
                            placeholder=""
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType"
                            size="mini"
                            name="aeoCodeType"
                            @focus="validateFieldCnCountryName"
                            @change="changCnAeoCodeType"
                            ref="ebFtPlanPartyCn.aeoCodeType"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="收货人企业代码:"
                        >
                          <el-input
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyCn.partyMainCode
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.partyMainCode"
                            case="upper"
                             maxlength="100"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-form-item
                      :class="['requiredStyle',ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName === 'TO ORDER'? 'noRequiredStyle': '']"
                      label="地址:"
                      prop="ebFtPlanPartyCn.partyAddress"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        type="textarea"
                        :rows="3"
                        v-model="ebFtPlanEditForm.ebFtPlanPartyCn.partyAddress"
                         maxlength="200"
                        :title="ebFtPlanEditForm.ebFtPlanPartyCn.partyAddress"
                        ref="ebFtPlanPartyCn.partyAddress"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item
                      label="中文名称:"
                      prop="ebFtPlanPartySh.partyMainNameCn"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="
                          ebFtPlanEditForm.ebFtPlanPartyCn.partyMainNameCn
                        "
                        :title="ebFtPlanEditForm.ebFtPlanPartyCn.partyMainNameCn"
                        maxlength="100"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="电话:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyCn.tel"
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.tel"
                             maxlength="50"
                            ref="ebFtPlanPartyCn.tel"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="传真:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyCn.fax"
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.fax"
                            maxlength="50"
                            ref="ebFtPlanPartyCn.fax"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="邮箱:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyCn.email"
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.email"
                            maxlength="50"
                            ref="ebFtPlanPartyCn.email"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="AEO企业代码:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyCn.aeoNo"
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.aeoNo"
                            maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="具体联系人">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyCn.contactPerson
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.contactPerson"
                            maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="具体联系人电话:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyCn.contactTel
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyCn.contactTel"
                            maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5"></el-row>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-row class="cargo-type transceiver-cargo-type">
              <el-row class="title-panel cargo-type-title-panel transceiver-info">
                <el-col>
                  <span class="title-text cargo-title-text">通知人</span>
                </el-col>
              </el-row>
                  <el-col style="position: relative">
                    <div class="NTContainer">
                      <el-radio
                        v-model="isCopyCNEE"
                        :label="true"
                        @change="copyCNEE" style="margin-left:5px"
                      >COPY CNEE
                      </el-radio
                      >
                      <el-radio
                        v-model="ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName"
                        label="SAME AS CNEE"
                        @change="changeCNEE"
                      >SAME AS CNEE
                      </el-radio
                      >
                    </div>
                    <el-form-item
                      :class="['requiredStyle',ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName === 'SAME AS CNEE'  ? 'noRequiredStyle': '']"
                      label="通知人名称:"
                      prop="ebFtPlanPartyNt.partyMainName"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName"
                        :title="ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName"
                        maxlength="100"
                        ref="ebFtPlanPartyNt.partyMainName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          :class="['requiredStyle',ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName === 'SAME AS CNEE'  ? 'noRequiredStyle': '']"
                          label="国家(地区):"
                          prop="ebFtPlanPartyNt.countryName"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_country"
                            :query-method="associate_queryMethod_country"
                            class="input_length"
                            clearable
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="countryNameEn"
                            value-prop="countryNameEn"
                            placeholder=""
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyNt.countryName
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.countryName"
                            size="mini"
                            name="countryName"
                            @change="validateFieldNt"
                            case="upper"
                            ref="ebFtPlanPartyNt.countryName"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="通知人代码:"
                          prop="ebFtPlanPartyNt.partySysCode"
                        >
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyNt.partySysCode
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.partySysCode"
                            maxlength="50"
                            ref="ebFtPlanPartyNt.partySysCode"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item
                          :class="['requiredStyle',ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName === 'SAME AS CNEE'  ? 'noRequiredStyle': '']"
                          label="通知人企业代码类型:"
                          prop="ebFtPlanPartyNt.aeoCodeType"
                        >
                          <el-associate
                            style="width: 100%"
                            :columns="associate_columns_aeoCodeType"
                            :query-method="associate_queryMethod_aeoCodeType_Nt"
                            class="input_length"
                            clearable
                            :allow-create="true"
                            :query-length="0"
                            :default-first-option="true"
                            label-prop="aeoCodeType"
                            value-prop="aeoCodeType"
                            placeholder=""
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType"
                            size="mini"
                            name="aeoCodeType"
                            ref="ebFtPlanPartyNt.aeoCodeType"
                            @focus="validateFieldNtCountryName"
                            @change="changNtAeoCodeType"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label="通知人企业代码:"
                        >
                          <el-input
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyNt.partyMainCode
                            "
                            case="upper"
                            maxlength="100"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-form-item
                      :class="['requiredStyle',ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName === 'SAME AS CNEE' ? 'noRequiredStyle': '']"
                      label="地址:"
                      prop="ebFtPlanPartyNt.partyAddress"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        type="textarea"
                        :rows="3"
                        v-model="ebFtPlanEditForm.ebFtPlanPartyNt.partyAddress"
                        :title="ebFtPlanEditForm.ebFtPlanPartyNt.partyAddress"
                        maxlength="200"
                        ref="ebFtPlanPartyNt.partyAddress"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item
                      label="中文名称:"
                      prop="ebFtPlanPartySh.partyMainNameCn"
                    >
                      <el-input
                        case="upper"
                        size="mini"
                        v-model="
                          ebFtPlanEditForm.ebFtPlanPartyNt.partyMainNameCn
                        "
                        :title="ebFtPlanEditForm.ebFtPlanPartyNt.partyMainNameCn"
                         maxlength="100"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="电话:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyNt.tel"
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.tel"
                             maxlength="50"
                            ref="ebFtPlanPartyNt.tel"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="传真:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyNt.fax"
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.fax"
                             maxlength="50"
                            ref="ebFtPlanPartyNt.fax"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="邮箱:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyNt.email"
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.email"
                             maxlength="50"
                            ref="ebFtPlanPartyNt.email"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="AEO企业代码:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="ebFtPlanEditForm.ebFtPlanPartyNt.aeoNo"
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.aeoNo"
                             maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5">
                      <el-col :span="12">
                        <el-form-item label="具体联系人">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyNt.contactPerson
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.contactPerson"
                            maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="具体联系人电话:">
                          <el-input
                            case="upper"
                            size="mini"
                            v-model="
                              ebFtPlanEditForm.ebFtPlanPartyNt.contactTel
                            "
                            :title="ebFtPlanEditForm.ebFtPlanPartyNt.contactTel"
                            maxlength="50"
                          >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col>
                    <el-row :gutter="5"></el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import {
  queryCarrierInfo,
  queryCountryInfo,
  queryDictRows,
  queryPoInfo,
  queryVoyageInfo,
  queryCountry,
} from "@/api/commonService";
import { editFromInfoValidate } from "@/rules/maniFestEditRules";
import { queryShippingDate } from '@/api/queryMainSystem';
import autoFocusMixin from "@/mixin/autoFocus";
import {validateWordFn} from "@/rules/validateWordFn";

export default {
  mixins: [autoFocusMixin],
  name: "editFromInfo",
  props: {
    ebFtPlanEditForm: {
      type: Object,
      default: function () {
        return {};
      },
    },
    pickerOptions: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isAddManiFest: {
      type: Boolean,
      default: true,
    },
    isAddManiFest1: {
      type: Boolean,
      default: true,
    },
    isAddManiFest2: {
      type: Boolean,
      default: true,
    },
    notEditable: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    'ebFtPlanEditForm.ebFtPlanPartyCn': {
      deep: true,
      handler() {
        this.isCopyCNEE = false;
      }
    },
    "ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName": {
      deep: true,
      handler(val) {
        if (val === 'SAME AS CNEE') {
          var newRules = {...this.ebFtPlanEditFormRules};
          if (newRules['ebFtPlanPartyNt.countryName'].length >= 1) {
            delete newRules['ebFtPlanPartyNt.countryName']
            delete newRules['ebFtPlanPartyNt.partyMainCode']
            delete newRules['ebFtPlanPartyNt.partySysCode']
            delete newRules['ebFtPlanPartyNt.aeoCodeType']
            delete newRules['ebFtPlanPartyNt.partyMainName']
            delete newRules['ebFtPlanPartyNt.partyAddress']
            this.ebFtPlanEditFormRules = newRules
          }
        } else {
          if (!this.isCopyCNEE) {
            var newRules = {...this.ebFtPlanEditFormRules};
            newRules['ebFtPlanPartyNt.countryName'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.partyMainCode'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.partySysCode'] = [
              {required: false, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.aeoCodeType'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.partyMainName'] = [
              {required: true, message: '请输入', trigger: 'blur'},
              { validator: validateWordFn.bind(70), trigger: 'blur' }
            ]
            newRules['ebFtPlanPartyNt.partyAddress'] = [
              {required: true, message: '请输入', trigger: 'blur'},
              { validator: validateWordFn.bind(70), trigger: 'blur' }
            ]
            this.ebFtPlanEditFormRules = newRules
          }
        }
        setTimeout(() => {
          this.$refs.ebFtPlanEditFormRef.clearValidate()
        })
      }
    },
    /*isCopyCNEE: {
      deep: true,
      handler(val) {
        if (val === true) {
          let newRules = JSON.parse(JSON.stringify(this.ebFtPlanEditFormRules));
          if (newRules['ebFtPlanPartyNt.countryName'].length >= 1) {
            delete newRules['ebFtPlanPartyNt.countryName']
            delete newRules['ebFtPlanPartyNt.partyMainCode']
            delete newRules['ebFtPlanPartyNt.partySysCode']
            delete newRules['ebFtPlanPartyNt.aeoCodeType']
            delete newRules['ebFtPlanPartyNt.partyMainName']
            delete newRules['ebFtPlanPartyNt.partyAddress']
            this.ebFtPlanEditFormRules = newRules
          }
        } else {
          if (this.ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName !== 'SAME AS CNEE') {
            let newRules = JSON.parse(JSON.stringify(this.ebFtPlanEditFormRules));
            newRules['ebFtPlanPartyNt.countryName'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.partyMainCode'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.partySysCode'] = [
              {required: false, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.aeoCodeType'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.partyMainName'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            newRules['ebFtPlanPartyNt.partyAddress'] = [
              {required: true, message: '请输入', trigger: 'blur'},
            ]
            this.ebFtPlanEditFormRules = newRules
          }
          setTimeout(() => {
            this.$refs.ebFtPlanEditFormRef.clearValidate()
          })
        }
      }
    },*/
    "ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName": {
      deep: true,
      handler(val) {
        if (val === 'TO ORDER') {
          var newRules = {...this.ebFtPlanEditFormRules};
          if (newRules['ebFtPlanPartyNt.countryName'].length >= 1) {
            delete newRules['ebFtPlanPartyCn.countryName']
            delete newRules['ebFtPlanPartyCn.partyMainCode']
            delete newRules['ebFtPlanPartyCn.partySysCode']
            delete newRules['ebFtPlanPartyCn.aeoCodeType']
            delete newRules['ebFtPlanPartyCn.partyMainName']
            delete newRules['ebFtPlanPartyCn.partyAddress']
            this.ebFtPlanEditFormRules = newRules
          }
        } else {
          var newRules = {...this.ebFtPlanEditFormRules};
          newRules['ebFtPlanPartyCn.countryName'] = [
            {required: true, message: '请输入', trigger: 'blur'},
          ]
          newRules['ebFtPlanPartyCn.partyMainCode'] = [
            {required: true, message: '请输入', trigger: 'blur'},
          ]
          newRules['ebFtPlanPartyCn.partySysCode'] = [
            {required: false, message: '请输入', trigger: 'blur'},
          ]
          newRules['ebFtPlanPartyCn.aeoCodeType'] = [
            {required: true, message: '请输入', trigger: 'blur'},
          ]
          newRules['ebFtPlanPartyCn.partyMainName'] = [
            {required: true, message: '请输入', trigger: 'blur'},
            { validator: validateWordFn.bind(70), trigger: 'blur' }
          ]
          newRules['ebFtPlanPartyCn.partyAddress'] = [
            {required: true, message: '请输入', trigger: 'blur'},
            { validator: validateWordFn.bind(70), trigger: 'blur' }
          ]
          this.ebFtPlanEditFormRules = newRules
        }
        setTimeout(() => {
          this.$refs.ebFtPlanEditFormRef.clearValidate()
        })
      }
    }
  },
  data() {
    return {
      isCopyCNEE: false,
      currentMdCountryId: "",
      currentCountryCode: "",
      currentCountryNameEn: "",
      ebFtPlanEditFormRules: {},
      billPropertyOptions: [],
      hblPaymentTypeOptions: [],
      hblTransportTermOptions: [],
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      //国家(地区)联想控件
      associate_columns_country: [
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "中文名称",
          field: "countryNameCn",
        },
        {
          title: "英文名称",
          field: "countryNameEn",
        },
      ],
      //收货地/装货港/中转港/卸货港/交货地联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      associate_columns_aeoCodeType: [
        {
          title: "国家",
          field: "countryCode",
        },
        {
          title: "企业代码类型",
          field: "aeoCodeType",
        },
      ],
    };
  },
  created() {

  },
  mounted() {
    this.getSelectList();
    this.ebFtPlanEditFormRules = editFromInfoValidate();
  },
  methods: {
    validateAutoFocus() {
      // let isAutoFocus = this.autoFocus(this.ebFtPlanEditForm, this.ebFtPlanEditFormRules);
      let self = this
      self.autoFocus(self.ebFtPlanEditForm,self.ebFtPlanEditFormRules);
    },
    copyCNEE() {

       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'partyMainName',this.ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'countryCode',this.ebFtPlanEditForm.ebFtPlanPartyCn.countryCode);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'mdCountryId',this.ebFtPlanEditForm.ebFtPlanPartyCn.mdCountryId);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'countryName',this.ebFtPlanEditForm.ebFtPlanPartyCn.countryName);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'partySysCode',this.ebFtPlanEditForm.ebFtPlanPartyCn.partySysCode);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'aeoCodeType',this.ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'partyMainCode',this.ebFtPlanEditForm.ebFtPlanPartyCn.partyMainCode);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'partyAddress',this.ebFtPlanEditForm.ebFtPlanPartyCn.partyAddress);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'partyMainNameCn',this.ebFtPlanEditForm.ebFtPlanPartyCn.partyMainNameCn);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'tel',this.ebFtPlanEditForm.ebFtPlanPartyCn.tel);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'fax',this.ebFtPlanEditForm.ebFtPlanPartyCn.fax);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'email',this.ebFtPlanEditForm.ebFtPlanPartyCn.email);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'aeoNo',this.ebFtPlanEditForm.ebFtPlanPartyCn.aeoNo);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'contactPerson',this.ebFtPlanEditForm.ebFtPlanPartyCn.contactPerson);
       this.$set(this.ebFtPlanEditForm.ebFtPlanPartyNt,'contactTel',this.ebFtPlanEditForm.ebFtPlanPartyCn.contactTel);

      this.isCopyCNEE = true
      this.$forceUpdate();
    },
    changeCNEE() {

      this.ebFtPlanEditForm.ebFtPlanPartyNt.countryCode = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.countryName = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.mdCountryId =
        this.currentMdCountryId = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.partySysCode = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.partyMainCode = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.partyAddress = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.partyMainNameCn = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.tel = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.fax = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.email = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.aeoNo = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.contactPerson = null;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.contactTel = null;
      this.isCopyCNEE = false;
    },
    changCnAeoCodeType(value, selectedRows){
      console.log("selectedRows", selectedRows);
      this.ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType = selectedRows.aeoCodeType;
      this.$forceUpdate();
    },
    validateFieldCnCountryName() {
      if (!this.ebFtPlanEditForm.ebFtPlanPartyCn.countryName) {
        this.$coreMethods.message("warning", "请先选择国家");
        this.$refs.aeoCodeTypeCnAssociate.blur();
        return;
      } else {
        this.currentMdCountryId =
          this.ebFtPlanEditForm.ebFtPlanPartyCn.mdCountryId;
        this.currentCountryCode = this.ebFtPlanEditForm.ebFtPlanPartyCn.countryCode;
        this.currentCountryNameEn = this.ebFtPlanEditForm.ebFtPlanPartyCn.countryName;
      }
    },
    changShAeoCodeType(value, selectedRows){
      console.log("selectedRows", selectedRows);
      this.ebFtPlanEditForm.ebFtPlanPartySh.aeoCodeType = selectedRows.aeoCodeType;
      this.$forceUpdate();
    },
    validateFieldShCountryName() {
      if (!this.ebFtPlanEditForm.ebFtPlanPartySh.countryName) {
        this.$coreMethods.message("warning", "请先选择国家");
        this.$refs.aeoCodeTypeShAssociate.blur();
        return;
      } else {
        this.currentMdCountryId = this.ebFtPlanEditForm.ebFtPlanPartySh.mdCountryId;
        this.currentCountryCode = this.ebFtPlanEditForm.ebFtPlanPartySh.countryCode;
        this.currentCountryNameEn = this.ebFtPlanEditForm.ebFtPlanPartySh.countryName;
      }
    },
    changNtAeoCodeType(value, selectedRows){
      console.log("selectedRows", selectedRows);
      this.ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType = selectedRows.aeoCodeType;
      this.$forceUpdate();
    },
    validateFieldNtCountryName() {
      if (!this.ebFtPlanEditForm.ebFtPlanPartyNt.countryName) {
        this.$coreMethods.message("warning", "请先选择国家");
        this.$refs.aeoCodeTypeNtAssociate.blur();
        return;
      } else {
        this.currentMdCountryId =
          this.ebFtPlanEditForm.ebFtPlanPartyNt.mdCountryId;
        this.currentCountryCode = this.ebFtPlanEditForm.ebFtPlanPartyNt.countryCode;
        this.currentCountryNameEn = this.ebFtPlanEditForm.ebFtPlanPartyNt.countryName;
      }
    },
    /*
     *validateField的同时赋值countryCode值
     */
    validateFieldSh(value, selectRow) {
      this.ebFtPlanEditForm.ebFtPlanPartySh.countryCode = selectRow.countryCode;
      this.ebFtPlanEditForm.ebFtPlanPartySh.mdCountryId = this.currentMdCountryId = selectRow.mdCountryId;
      this.validateField("ebFtPlanPartySh.countryName");
      this.ebFtPlanEditForm.ebFtPlanPartySh.aeoCodeType = null;
      if (!this.ebFtPlanEditForm.ebFtPlanPartySh.mdCountryId) return
      this.associate_queryMethod_aeoCodeType_Sh({});
    },
    validateFieldCn(value, selectRow) {
      this.ebFtPlanEditForm.ebFtPlanPartyCn.countryCode = selectRow.countryCode;
      this.ebFtPlanEditForm.ebFtPlanPartyCn.mdCountryId =
        this.currentMdCountryId = selectRow.mdCountryId;
      this.validateField("ebFtPlanPartyCn.countryName");
      this.ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType = null;
      if (!this.ebFtPlanEditForm.ebFtPlanPartyCn.mdCountryId) return
      this.associate_queryMethod_aeoCodeType_Cn({});
    },
    validateFieldNt(value, selectRow) {
      this.ebFtPlanEditForm.ebFtPlanPartyNt.countryCode = selectRow.countryCode;
      this.ebFtPlanEditForm.ebFtPlanPartyNt.mdCountryId =
        this.currentMdCountryId = selectRow.mdCountryId;
      this.validateField("ebFtPlanPartyNt.countryName");
      this.ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType = null;
      if (!this.ebFtPlanEditForm.ebFtPlanPartyNt.mdCountryId) return
      this.associate_queryMethod_aeoCodeType_Nt({});
    },
    changeMblPaymentType() {
      this.$refs.ebFtPlanEditFormRef.validateField("ebOrder.mblPaymentType");
    },
    validateField(field) {
      this.$refs.ebFtPlanEditFormRef.validateField(field);
    },
    validateEditFromInfo(submitType) {
      // this.$emit('validateEditFromInfoSuccess',submitType)
      this.$refs.ebFtPlanEditFormRef.validate((values) => {
        if (values) {
          this.$emit("validateEditFromInfoSuccess", submitType);
        }
      });
    },
    editFromValidate: function (callback) {
      let self = this;
      let validM = true;
      self.$refs.ebFtPlanEditFormRef.validate(async (validD) => {
            validM = validD;
              if (callback) callback(validM);
      });
    },
     //校验
    // validateEditFromInfo() {
    //   let self = this;
    //   let flag = false;
    //   self.$refs.ebFtPlanEditFormRef.validate(item => {
    //     flag = item
    //   });
    //   if (flag){
    //     return true
    //   }
    // },
    //获取数据字典
    getSelectList() {
      queryDictRows(
        "MD_CODE_DICT$EB_PAYMENTMODE,MD_CODE_DICT$BILL_TYPE,MD_CODE_DICT$TRANSPORT_TERM"
      ).then((res) => {
        /*name:value value:key*/
        console.log("queryDictRows:", res);
        //付款方式
        this.hblPaymentTypeOptions = res.MD_CODE_DICT$EB_PAYMENTMODE;
        //运输条款
        this.hblTransportTermOptions = res.MD_CODE_DICT$TRANSPORT_TERM;
        //提单性质
        this.billPropertyOptions = res.MD_CODE_DICT$BILL_TYPE;
      });
    },
    associate_queryMethod_shipAgencyName({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SA%",
          isDeleted6: "0",
          isBlacklist: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SA%",
          isDeleted6: "0",
          isBlacklist: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where:
          "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)\n",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
          isBlacklist: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          isBlacklist: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where:
          "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)\n",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        if(this.ebFtPlanEditForm.ebOrder.vesselNameEn === ""){
          params = {
            isDeleted2: "0"
          };
        }else{
          params = {
            isDeleted2: "0",
            vesselName: this.ebFtPlanEditForm.ebOrder.vesselNameEn
          };
        }
      } else {
        if(this.ebFtPlanEditForm.ebOrder.vesselNameEn === ""){
          params = {
            vesselName0: "%" + keyword + "%",
            voyage1: "%" + keyword + "%"
          };
        }else{
          params = {
            vesselName0: "%" + keyword + "%",
            voyage1: "%" + keyword + "%",
            vesselName: this.ebFtPlanEditForm.ebOrder.vesselNameEn
          };
        }
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "((((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2) AND CTS_ILPMdVoyagePlan.vesselName = :vesselName)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    associate_queryMethod_aeoCodeType_Sh({keyword, pageSize, currentPage}) {
      return this.associate_queryMethod_aeoCodeType(
        {keyword, pageSize, currentPage},
        "Sh"
      );
    },
    associate_queryMethod_aeoCodeType_Cn({keyword, pageSize, currentPage}) {
      return this.associate_queryMethod_aeoCodeType(
        {keyword, pageSize, currentPage},
        "Cn"
      );
    },
    associate_queryMethod_aeoCodeType_Nt({keyword, pageSize, currentPage}) {
      return this.associate_queryMethod_aeoCodeType(
        {keyword, pageSize, currentPage},
        "Nt"
      );
    },
    associate_queryMethod_aeoCodeType(
      {keyword, pageSize, currentPage},
      type
    ) {
      let self = this;
      switch (type) {
        case "Sh":
          self.currentMdCountryId =
            self.ebFtPlanEditForm.ebFtPlanPartySh.mdCountryId;
          self.currentCountryCode = self.ebFtPlanEditForm.ebFtPlanPartySh.countryCode;
          self.currentCountryNameEn = self.ebFtPlanEditForm.ebFtPlanPartySh.countryName;
          break;
        case "Cn":
          self.currentMdCountryId =
            self.ebFtPlanEditForm.ebFtPlanPartyCn.mdCountryId;
          self.currentCountryCode = self.ebFtPlanEditForm.ebFtPlanPartyCn.countryCode;
          self.currentCountryNameEn = self.ebFtPlanEditForm.ebFtPlanPartyCn.countryName;
          break;
        case "Nt":
          self.currentMdCountryId =
            self.ebFtPlanEditForm.ebFtPlanPartyNt.mdCountryId;
          self.currentCountryCode = self.ebFtPlanEditForm.ebFtPlanPartyNt.countryCode;
          self.currentCountryNameEn = self.ebFtPlanEditForm.ebFtPlanPartyNt.countryName;
          break;
      }
      let data = {
        mdCountryId: self.currentMdCountryId,
        countryCode: self.currentCountryCode,
        countryNameEn: self.currentCountryNameEn

      };
      return new Promise((resolve) => {
        queryCountry(data).then((res) => {
          let result = res.records;
          let resultList = result.aeoCodeType.split(",");
          if (resultList.length === 1) {
            self.ebFtPlanEditForm["ebFtPlanParty" + type]["aeoCodeType"] =
              resultList[0];
            this.$emit("update:ebFtPlanEditForm", self.ebFtPlanEditForm);
            this.$forceUpdate();
          }
          let records = resultList.map((item) => {
            return {
              aeoCodeType: item,
              countryCode: result.countryCode,
            };
          });
          resolve({
            records,
            total: records.length,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },

    // 国家(地区)联想控件数据源
    associate_queryMethod_country({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
          isActive4: "1",
        };
      } else {
        params = {
          countryCode0: "%" + keyword + "%",
          countryNameCn1: "%" + keyword + "%",
          countryNameEn2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdCountry.countryCode"],
        mainModelName: "CTS_ILPMdCountry",
        tag: "CTS_ILP_es",
        where:
          "((((CTS_ILPMdCountry.countryCode LIKE :countryCode0 OR CTS_ILPMdCountry.countryNameCn LIKE :countryNameCn1) OR CTS_ILPMdCountry.countryNameEn LIKE :countryNameEn2) AND CTS_ILPMdCountry.isDeleted = :isDeleted3) AND CTS_ILPMdCountry.isActive = :isActive4)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdCountry.mdCountryId",
          "CTS_ILPMdCountry.isDeleted",
          "CTS_ILPMdCountry.lastModifyTime",
          "CTS_ILPMdCountry.lastModifierName",
          "CTS_ILPMdCountry.countryNameCn",
          "CTS_ILPMdCountry.appCode",
          "CTS_ILPMdCountry.continentsCode",
          "CTS_ILPMdCountry.createOfficeName",
          "CTS_ILPMdCountry.createOffice",
          "CTS_ILPMdCountry.creatorId",
          "CTS_ILPMdCountry.countryCode",
          "CTS_ILPMdCountry.countryNameEn",
          "CTS_ILPMdCountry.isActive",
          "CTS_ILPMdCountry.lastModifyOffice",
          "CTS_ILPMdCountry.createTime",
          "CTS_ILPMdCountry.principalGroupCode",
          "CTS_ILPMdCountry.recordVersion",
          "CTS_ILPMdCountry.lastModifyOfficeName",
          "CTS_ILPMdCountry.creatorName",
          "CTS_ILPMdCountry.lastModifierId",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryCountryInfo(data).then((res) => {
          console.log("queryCountryInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 收货地/装货港/中转港/卸货港/交货地联想控件数据源
    associate_queryMethod_po({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //船公司修改事件
    carrierChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.carrierId = selectedRows.csCustId;
      this.ebFtPlanEditForm.ebOrder.carrierName =  selectedRows.custAlias;
      this.ebFtPlanEditForm.ebOrder.carrierName1 =  selectedRows.custNameCn;
      this.queryShippingDate();
    },
    //船代修改事件
    shipAgencyChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.shipAgencyId = selectedRows.csCustId;
    },
    queryShippingDate(){
      let self = this;
      let shippingSearchData= {
          currentPage: 1,
          pageSize: 100,
      };
      shippingSearchData.vesselName = self.ebFtPlanEditForm.ebOrder.vesselNameEn;
      shippingSearchData.voyage = self.ebFtPlanEditForm.ebOrder.realVoyage;
      shippingSearchData.carrierName = self.ebFtPlanEditForm.ebOrder.carrierName;
      shippingSearchData.carrierId = self.ebFtPlanEditForm.ebOrder.carrierId;
      shippingSearchData.callingPortName = self.ebFtPlanEditForm.ebOrder.polName;
      shippingSearchData.callingPortId = self.ebFtPlanEditForm.ebOrder.polId;
      if(self.ebFtPlanEditForm.ebOrder.carrierName !=="" && self.ebFtPlanEditForm.ebOrder.carrierName !==null && self.ebFtPlanEditForm.ebOrder.carrierName !==undefined
        && self.ebFtPlanEditForm.ebOrder.vesselNameEn !=="" && self.ebFtPlanEditForm.ebOrder.vesselNameEn !==null && self.ebFtPlanEditForm.ebOrder.vesselNameEn !==undefined
        && self.ebFtPlanEditForm.ebOrder.polName !=="" && self.ebFtPlanEditForm.ebOrder.polName !==null && self.ebFtPlanEditForm.ebOrder.polName !==undefined
        && self.ebFtPlanEditForm.ebOrder.realVoyage !==  "" && self.ebFtPlanEditForm.ebOrder.realVoyage !==null && self.ebFtPlanEditForm.ebOrder.realVoyage !==  undefined){
        queryShippingDate(shippingSearchData).then((res) => {
          if (res.success) {
            self.ebFtPlanEditForm.ebOrder.etd = res.records.records[0].etd;
            self.ebFtPlanEditForm.ebOrder.shipAgencyName = res.records.records[0].portAreaName;
            self.ebFtPlanEditForm.ebOrder.shipAgencyId = res.records.records[0].portAreaId;
            self.ebFtPlanEditForm.ebOrder.customsVesselName = res.records.records[0].customsVesselName;
            self.ebFtPlanEditForm.ebOrder.customsVesselId = res.records.records[0].customsVesselId;
            self.ebFtPlanEditForm.ebOrder.customsVoyage = res.records.records[0].customsVoyage;
          }
          self.$forceUpdate();
        });
      }
    },
    realVesselChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.realVesselId = selectedRows.vesselId;
      this.ebFtPlanEditForm.ebOrder.vesselNameEn = selectedRows.vesselName;
      this.ebFtPlanEditForm.ebOrder.voyage = selectedRows.voyage;
      this.queryShippingDate();
      this.$forceUpdate();
    },
    //船名修改事件
    vesselChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.customsVesselId = selectedRows.vesselId;
      this.ebFtPlanEditForm.ebOrder.customsVesselName = selectedRows.vesselName;
      this.ebFtPlanEditForm.ebOrder.customsVoyage = selectedRows.voyage;
      this.$forceUpdate();
    },
    realVoyageChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.voyage = selectedRows.voyage;
      this.queryShippingDate();
      this.$forceUpdate();
    },
    voyageChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.customsVoyage = selectedRows.voyage;
    },
    //起运港修改事件
    polChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.polId = selectedRows.mdPortId;
      this.ebFtPlanEditForm.ebOrder.polCode = selectedRows.portCode;
      this.queryShippingDate();
      this.$forceUpdate();
    },
    //卸货港修改事件
    podChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebOrder.podId = selectedRows.mdPortId;
      this.ebFtPlanEditForm.ebOrder.podCode = selectedRows.portCode;
    },
    //目的港修改事件
    placeOfDestChange(value, selectedRows) {
      console.log(selectedRows);
      this.ebFtPlanEditForm.ebFtPlan.placeOfDestId = selectedRows.mdPortId;
    },
  },
};
</script>

<style>
.requiredStyle .el-form-item__label {
  color: red;
}

.noRequiredStyle .el-form-item__label {
  color: black;
}

.NTContainer {
  display: flex;
  position: absolute;
  left: 80px;
  top: 2px
}

.NTContainer label {
  margin-right: 5px;
}
</style>
